import React from "react";
import { FaLock, FaUnlock } from "react-icons/fa";

function ToggleBar({ isOpen, setIsOpen }) {
  return (
    <div style={{
      position: "fixed",
      top: "150px",
      left: "20px",
      zIndex: 2001,
      display: "flex",
      alignItems: "center"
    }}>
      <div
        onClick={() => setIsOpen(open => !open)}
        style={{
          width: 70,
          height: 40,
          borderRadius: 20,
          background: isOpen ? "linear-gradient(90deg, #e55050, #a993ea 80%)" : "linear-gradient(90deg, #ffe1e1, #ece9f7 80%)",
          boxShadow: "0 2px 12px #a993ea40",
          display: "flex",
          alignItems: "center",
          position: "relative",
          cursor: "pointer",
          transition: "background 0.25s"
        }}
      >
        <div style={{
          position: "absolute",
          left: isOpen ? 38 : 8,
          top: 6,
          width: 28,
          height: 28,
          background: "#fff",
          borderRadius: "50%",
          boxShadow: "0 2px 4px #a993ea33",
          transition: "left 0.25s"
        }} />
        <div style={{
          marginLeft: isOpen ? 10 : 29,
          transition: "margin 0.25s"
        }}>
          {isOpen ? <FaUnlock size={22} color="#222" /> : <FaLock size={22} color="#222" />}
        </div>
      </div>
    </div>
  );
}

export default ToggleBar;
